import React from 'react';
import { Button, FlexBox, Icon, Link, responsive } from '@vp/swan';

type IconType =
    | 'orderHistory'
    | 'phoneCall'
    | 'workWithAPro'
    | 'designerMarketplace'
    | 'download'
    | 'myProjects'
    | 'edit'
    | 'delete'
    | 'star';

export type CTA = {
    label: string;
    iconType: IconType;
    skin?: 'primary' | 'tertiary';
    href?: string;
    onClick: () => void;
    openInNewTab?: boolean;
};

type RequestCardCTAProps = {
    ctas: CTA[];
};

export const RequestCardCTA: React.FC<RequestCardCTAProps> = ({ ctas }) => {
    const ResponsiveFlexBox = responsive(FlexBox);

    return (
        <ResponsiveFlexBox
            style={{ flexShrink: 0 }}
            xs={{
                alignItems: 'center',
                flexDirection: 'column',
                gap: 'between-actions',
                style: { minWidth: 'auto' },
            }}
            sm={{
                alignItems: 'flex-start',
                style: { minWidth: '200px' },
            }}
        >
            {ctas.map(({ label, iconType, onClick, href, openInNewTab, skin = 'primary' }, i) => {
                const button = (
                    <Button
                        key={i}
                        skin={skin}
                        compactMode
                        iconPosition="left"
                        onClick={(e) => {
                            e.preventDefault();
                            onClick();
                            if (href) {
                                window.open(href, openInNewTab ? '_blank' : '_self');
                            }
                        }}
                    >
                        <Icon iconType={iconType} />
                        {label}
                    </Button>
                );

                return href ? (
                    <Link key={`cta-link-${i}`} href={href} render={() => button} />
                ) : (
                    <React.Fragment key={`cta-btn-${i}`}>{button}</React.Fragment>
                );
            })}
        </ResponsiveFlexBox>
    );
};
